import { render, staticRenderFns } from "./editinsidetalk.vue?vue&type=template&id=e6126520&scoped=true&"
import script from "./editinsidetalk.vue?vue&type=script&lang=js&"
export * from "./editinsidetalk.vue?vue&type=script&lang=js&"
import style0 from "./editinsidetalk.vue?vue&type=style&index=0&id=e6126520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6126520",
  null
  
)

export default component.exports